import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Audit } from 'app/core/models/audit.model';
import { LimitOffsetPaging } from 'app/core/models/paged-results/limit-offset-paging.model';
import { PagedProviderAudits, ProviderService } from 'app/core/services/provider.service';
import { Provider } from 'app/core/models/provider.model';

import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { AuditProviderCreateRowComponent } from '../../components/audit-provider-create-row/audit-provider-create-row.component';
import { AuditProviderUpdateRowComponent } from '../../components/audit-provider-update-row/audit-provider-update-row.component';
import { AuditNoteCreateRowComponent } from '../../components/audit-note-create-row/audit-note-create-row.component';
import { AuditProviderOfficeCreateRowComponent } from '../../components/audit-provider-office-create-row/audit-provider-office-create-row.component';
import { AuditProviderOfficeUpdateRowComponent } from '../../components/audit-provider-office-update-row/audit-provider-office-update-row.component';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AuditProviderDataReviewCreateRowComponent } from 'app/capture-admin/components/audit-provider-data-review-create-row/audit-provider-data-review-create-row.component';
import { AuditProviderDataReviewUpdateRowComponent } from 'app/capture-admin/components/audit-provider-data-review-update-row/audit-provider-data-review-update-row.component';

@Component({
    selector: 'app-capture-admin-provider-audit',
    templateUrl: './capture-admin-provider-audit.component.html',
    styleUrls: ['./capture-admin-provider-audit.component.scss'],
    imports: [PaginationHeaderComponent,
              AuditProviderCreateRowComponent,
              AuditProviderUpdateRowComponent,
              AuditNoteCreateRowComponent,
              AuditProviderOfficeCreateRowComponent,
              AuditProviderOfficeUpdateRowComponent,
              AuditProviderDataReviewCreateRowComponent,
              AuditProviderDataReviewUpdateRowComponent,
              PaginationComponent,
              MatProgressSpinner]
})
export class CaptureAdminProviderAuditComponent implements OnInit {
  private providerService = inject(ProviderService);
  private route = inject(ActivatedRoute);

  provider: Provider;
  audits: Audit[];

  loadingProvider: boolean;
  loadingAudits: boolean;

  paging: LimitOffsetPaging;

  ngOnInit() {
    this.paging = LimitOffsetPaging.empty;
    this.paging.currentPage = 1;
    this.init();
  }

  onPageSizeChange(size: number) {
    this.paging.pageSize = size;
    this.loadAudits(this.paging.currentPage);
  }

  onPageChange(page: number) {
    this.loadAudits(page);
  }

  private init() {
    const npi = this.route.snapshot.paramMap.get('npi');
    this.loadingProvider = true;
    this.providerService.getByNpi(npi).subscribe(provider => {
      this.provider = provider;
      this.loadingProvider = false;
      this.loadAudits(this.paging.currentPage);
    });
  }

  private loadAudits(page: number) {
    const paging = { page, pageSize: this.paging.pageSize };

    this.loadingAudits = true;

    this.providerService.getAudits(this.provider, paging).subscribe((result: PagedProviderAudits) => {
      this.audits = result.records;
      this.paging = result.meta.paging;
      this.loadingAudits = false
    })
  }

}
